import { connect } from "react-redux";
import { formatTimeTxt } from "../../../services/helpers/Helper";
import ListPostComment from "./list-post-comment";
import React from "react";
import { fetchPostComment } from "../../../store/action/commentPostAction";

const TablePost = (props) => {
  const { posts, fetchPostComment } = props;
  const [showListComment, setShowListComment] = React.useState(false);

  const handleShowListComment = (id) => {
    fetchPostComment(id, () => setShowListComment(!showListComment));
  }
  return (
    <React.Fragment>
      <table className="app-table app-table--vertical-middle">
        <thead>
          <tr>
            <th className="" style={{ width: 110 }}><span>Bài viết</span></th>
            <th className="" style={{ width: 110 }}><span>Trạng thái</span></th>
            <th className="" style={{ width: 110 }}><span>Thời gian đăng</span></th>
            <th className="" style={{ width: 110 }}><span>Xem bình luận</span></th>
            <th className="" style={{ width: 110 }}><span>Quảng cáo bài viết</span></th>
            {/* <th className="" style={{ width: 110 }}><span>Hành động</span></th> */}
          </tr>
        </thead>
        <tbody>
          {posts.map((item, index) => {
            return (
              <tr className="app-v2-table-row" key={index}>
                <td className="pointer" style={{ width: 110 }}>
                  <div className="card-feed-in-table-container">
                    <div className="card-feed-in-table-thumb">
                      <img className="card-feed-in-table-img" src={item.full_picture} />
                    </div>
                    <div className="card-feed-in-table-info">
                      <span className="card-feed-in-table-info__title">
                        <span className="title-hover" title={item.message}>
                          {item.message}
                        </span>
                      </span>
                      <span className="card-feed-in-table-info__subtitle">
                        Thời gian tạo: {formatTimeTxt(item.created_time)}
                      </span>
                    </div>
                  </div>
                </td>
                <td className="pointer" style={{ width: 110 }}>
                  <div className="status-feed-drafts">Lưu nháp</div>
                </td>
                <td className="pointer" style={{ width: 110 }}>
                  <span> {formatTimeTxt(item.created_time)}</span>
                </td>
                <td className="pointer" style={{ width: 110 }} onClick={() => handleShowListComment(item.id)}>
                  <span>Xem bình luận</span>
                </td>
                <td className="pointer" style={{ width: 110 }}>
                  <span className="button-disable-in-table">
                    Quảng cáo bài  viết
                  </span>
                </td>
                {/* <td className="pointer" style={{ width: 110 }}>
                  <div>
                    <a className="pointer text-note ml8 mr16">
                      <div className="svg-next-icon ic-edit-2">
                      </div>
                    </a>
                    <a className="hover-alert icon-delete pointer text-note">
                      <div className="svg-next-icon ic-trash">
                      </div>
                    </a>
                  </div>
                </td> */}
              </tr>
            )
          })}
        </tbody>
      </table>
      {showListComment && <ListPostComment onClose={() => setShowListComment(false)}/>}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  const { posts } = state;
  return {
    posts
  };
};

export default connect(mapStateToProps, {
  fetchPostComment
})(TablePost)